import type { ProxyRecord } from 'src/services/deserializers/deserializers.types'
import type {
  ContextualFieldInterface,
  FieldInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'
import { withTranslate } from 'src/tpbp-configuration/utils/i18n.utils'
import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import {
  FIELD_RULES,
  type FieldStatus,
} from 'src/tpbp-core/models/fields/fieldRules.const'
import {
  emailValidator,
  integerValidator,
  numberValidator,
  phoneNumberValidator,
  requiredValidator,
} from 'src/tpbp-core/models/fields/fields.validator'
import type { InputValidationRules } from 'src/tpbp-core/models/fields/inputs.types'
import { TEXT_INPUT_FORMATS } from 'src/tpbp-core/models/fields/text-input.const'

export function getFieldRules(
  field: FieldInterface,
  status: FieldStatus,
  record: ProxyRecord | undefined,
): InputValidationRules {
  const rules = _extractRules(field, record)

  if (field.format === TEXT_INPUT_FORMATS.email)
    rules.push(withTranslate(emailValidator))

  if (field.format === TEXT_INPUT_FORMATS.phone)
    rules.push(withTranslate(phoneNumberValidator))

  if (field.type === FIELD_TYPES.integer)
    rules.push(withTranslate(integerValidator))

  if (field.type === FIELD_TYPES.number)
    rules.push(withTranslate(numberValidator))

  if (
    field.status === FIELD_RULES.isMandatory ||
    status === FIELD_RULES.isMandatory
  ) {
    rules.push(withTranslate(requiredValidator))
  }

  return rules
}

function _extractRules(
  field: FieldInterface,
  record: ProxyRecord | undefined,
): InputValidationRules {
  if (!record) return []

  const fieldRules = field.getRules?.(record) as InputValidationRules

  return fieldRules ? [...fieldRules] : []
}

export function setFieldMandatory(
  field: ContextualFieldInterface,
): string | undefined {
  if (field.status === FIELD_RULES.isMandatory) return

  field.rules.push(withTranslate(requiredValidator))

  return FIELD_RULES.isMandatory
}
